import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["expanded", "onClickEvent", "itemKey", "children", "style", "className", "title", "templateHeader", "accordionHeaderId", "excludeElementToToggle", "toggleFromBody", "toggleFromHeaderIconOnly", "inclElementToToggle", "showExpandIcon", "accordionId", "accordionRef"];
import React from 'react';
import PropTypes from 'prop-types';
import ClassNames from 'classnames';
import { KEY_VALUES, SlideDown } from '../utils';
;
var AccordionItem = function AccordionItem(props) {
  var expanded = props.expanded,
    onClickEvent = props.onClickEvent,
    itemKey = props.itemKey,
    children = props.children,
    style = props.style,
    className = props.className,
    title = props.title,
    templateHeader = props.templateHeader,
    accordionHeaderId = props.accordionHeaderId,
    _props$excludeElement = props.excludeElementToToggle,
    excludeElementToToggle = _props$excludeElement === void 0 ? '' : _props$excludeElement,
    _props$toggleFromBody = props.toggleFromBody,
    toggleFromBody = _props$toggleFromBody === void 0 ? false : _props$toggleFromBody,
    _props$toggleFromHead = props.toggleFromHeaderIconOnly,
    toggleFromHeaderIconOnly = _props$toggleFromHead === void 0 ? false : _props$toggleFromHead,
    _props$inclElementToT = props.inclElementToToggle,
    inclElementToToggle = _props$inclElementToT === void 0 ? '' : _props$inclElementToT,
    _props$showExpandIcon = props.showExpandIcon,
    showExpandIcon = _props$showExpandIcon === void 0 ? true : _props$showExpandIcon,
    accordionId = props.accordionId,
    accordionRef = props.accordionRef,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  var contentRef = React.useRef(null);
  var wrapperRef = React.useRef(null);
  var classes = ClassNames('ap-accordion', className, {
    'expanded': expanded
  });
  var classesIcon = ClassNames('Appkit4-icon icon-down-chevron-outline', {
    'rotate': expanded
  });
  var classesContent = ClassNames('ap-accordion-content', {
    'hidden': !expanded,
    'ap-accordion-cursor-default': !toggleFromBody
  });

  // const height = React.useMemo(() => {
  //     if (wrapperRef?.current) {
  //         setTimeout(() => {
  //             return wrapperRef?.current?.getBoundingClientRect().height
  //         }, 0);
  //     }
  //     return undefined;
  // }, [expanded, children]);

  var getClosestElement = function getClosestElement(target, name) {
    return hasElement(false, target, name);
  };
  var focusElementSelector = function focusElementSelector(name, element) {
    var _querySelector;
    (_querySelector = element.querySelector(name)) === null || _querySelector === void 0 ? void 0 : _querySelector.focus();
  };
  var onKeyDownEvent = function onKeyDownEvent(event) {
    var _getClosestElement, _getClosestElement3, _querySelector2, _getClosestElement5, _getClosestElement6;
    var target = event.target;
    var nextEle, previousEle;
    var childEles;
    switch (event.key) {
      case KEY_VALUES.DOWN:
        event.preventDefault();
        nextEle = (_getClosestElement = getClosestElement(target, '.ap-accordion')) === null || _getClosestElement === void 0 ? void 0 : _getClosestElement.nextElementSibling;
        if (!nextEle) {
          var _getClosestElement2;
          nextEle = (_getClosestElement2 = getClosestElement(target, '.ap-accordion-group-container')) === null || _getClosestElement2 === void 0 ? void 0 : _getClosestElement2.firstChild;
        }
        nextEle && focusElementSelector('.ap-accordion-toggle', nextEle);
        break;
      case KEY_VALUES.UP:
        event.preventDefault();
        previousEle = (_getClosestElement3 = getClosestElement(target, '.ap-accordion')) === null || _getClosestElement3 === void 0 ? void 0 : _getClosestElement3.previousElementSibling;
        if (!previousEle) {
          var _getClosestElement4;
          var _childEles = (_getClosestElement4 = getClosestElement(target, '.ap-accordion-group-container')) === null || _getClosestElement4 === void 0 ? void 0 : _getClosestElement4.children;
          previousEle = _childEles && _childEles[_childEles.length - 1];
        }
        (_querySelector2 = previousEle.querySelector('.ap-accordion-toggle')) === null || _querySelector2 === void 0 ? void 0 : _querySelector2.focus();
        previousEle && focusElementSelector('.ap-accordion-toggle', previousEle);
        break;
      case KEY_VALUES.HOME:
        event.preventDefault();
        childEles = (_getClosestElement5 = getClosestElement(target, '.ap-accordion-group-container')) === null || _getClosestElement5 === void 0 ? void 0 : _getClosestElement5.children;
        var firstAccordionEle = childEles && childEles[0];
        firstAccordionEle && focusElementSelector('.ap-accordion-toggle', firstAccordionEle);
        break;
      case KEY_VALUES.END:
        event.preventDefault();
        childEles = (_getClosestElement6 = getClosestElement(target, '.ap-accordion-group-container')) === null || _getClosestElement6 === void 0 ? void 0 : _getClosestElement6.children;
        var lastAccordionEle = childEles && childEles[childEles.length - 1];
        lastAccordionEle && focusElementSelector('.ap-accordion-toggle', lastAccordionEle);
        break;
    }
  };
  var hasElement = function hasElement(isKeyboard, targetElement, name) {
    var _targetElement$parent;
    return isKeyboard ? ((_targetElement$parent = targetElement.parentNode) === null || _targetElement$parent === void 0 ? void 0 : _targetElement$parent.querySelector(name)) || targetElement.querySelector(name) : targetElement.closest(name);
  };
  var excludeElementToToggleFunc = function excludeElementToToggleFunc(target, isKeyboard) {
    return excludeElementToToggle && hasElement(isKeyboard, target, excludeElementToToggle);
  };
  var inclElementToToggleFunc = function inclElementToToggleFunc(target, isKeyboard) {
    return inclElementToToggle && hasElement(isKeyboard, target, inclElementToToggle);
  };
  var isTextInput = function isTextInput(target) {
    return target.tagName.toLowerCase() === 'textarea' || target.getAttribute('type') === 'text';
  };
  var keyEvent = function keyEvent(event) {
    event.preventDefault();
    clickEvent(event, true);
  };
  var getTarget = function getTarget(event) {
    return event === null || event === void 0 ? void 0 : event.target;
  };
  var onEnterEvent = function onEnterEvent(event) {
    var target = getTarget(event);
    if ([KEY_VALUES.ENTER, KEY_VALUES.SPACE].includes(event.key)) {
      if (isTextInput(target)) {
        return;
      }
      keyEvent(event);
    }
  };
  var onEnterEventElement = function onEnterEventElement(event) {
    var target = getTarget(event);
    if ([KEY_VALUES.ENTER, KEY_VALUES.SPACE].includes(event.key)) {
      if (isTextInput(target)) {
        return;
      }
      if (inclElementToToggleFunc(target, true)) {
        keyEvent(event);
      }
    }
  };
  var clickEvent = function clickEvent(event, isKeyboard) {
    if (isKeyboard === void 0) {
      isKeyboard = false;
    }
    event.stopPropagation();
    var target = getTarget(event);
    if (excludeElementToToggleFunc(target, isKeyboard)) {
      return;
    }
    onClickEvent && onClickEvent(event, itemKey);
  };
  var clickEventElement = function clickEventElement(event, isKeyboard) {
    if (isKeyboard === void 0) {
      isKeyboard = false;
    }
    event.stopPropagation();
    var target = getTarget(event);
    if (inclElementToToggleFunc(target, isKeyboard)) {
      onClickEvent && onClickEvent(event, itemKey);
    }
  };
  return /*#__PURE__*/React.createElement("li", _extends({
    className: classes,
    style: style,
    onKeyDown: onKeyDownEvent
  }, rest), /*#__PURE__*/React.createElement("div", {
    className: "ap-accordion-toggle " + (toggleFromHeaderIconOnly ? 'ap-accordion-cursor-default' : ''),
    tabIndex: toggleFromHeaderIconOnly ? undefined : 0,
    id: accordionHeaderId,
    role: "tab",
    "aria-expanded": toggleFromHeaderIconOnly ? undefined : expanded,
    "aria-selected": toggleFromHeaderIconOnly ? undefined : expanded,
    "aria-controls": toggleFromHeaderIconOnly ? undefined : accordionId ? accordionId + itemKey : itemKey,
    onClick: toggleFromHeaderIconOnly ? inclElementToToggle ? clickEventElement : undefined : clickEvent,
    onKeyDown: toggleFromHeaderIconOnly ? inclElementToToggle ? onEnterEventElement : undefined : onEnterEvent
  }, title ? /*#__PURE__*/React.createElement("div", {
    className: "ap-accordion-title ap-font-medium"
  }, title) : /*#__PURE__*/React.createElement("div", {
    className: "ap-accordion-title-extra ap-accordion-title ap-font-medium"
  }, templateHeader === null || templateHeader === void 0 ? void 0 : templateHeader()), showExpandIcon && /*#__PURE__*/React.createElement("div", {
    className: "ap-accordion-toggle-icon-container",
    role: toggleFromHeaderIconOnly ? 'button' : undefined,
    tabIndex: toggleFromHeaderIconOnly ? 0 : undefined,
    "aria-expanded": toggleFromHeaderIconOnly ? expanded : undefined,
    "aria-selected": toggleFromHeaderIconOnly ? expanded : undefined,
    "aria-controls": toggleFromHeaderIconOnly ? accordionId ? accordionId + itemKey : itemKey : undefined,
    onClick: toggleFromHeaderIconOnly ? clickEvent : undefined,
    onKeyDown: toggleFromHeaderIconOnly ? onEnterEvent : undefined
  }, /*#__PURE__*/React.createElement("span", {
    className: classesIcon,
    "aria-hidden": true
  }))), /*#__PURE__*/React.createElement(SlideDown, {
    id: accordionId ? accordionId + itemKey : itemKey
  }, /*#__PURE__*/React.createElement("div", {
    id: accordionId ? accordionId + itemKey : itemKey,
    className: classesContent,
    role: "tabpanel",
    tabIndex: toggleFromBody ? 0 : undefined,
    ref: contentRef,
    onClick: toggleFromBody ? clickEvent : inclElementToToggle ? clickEventElement : undefined,
    onKeyDown: toggleFromBody ? onEnterEvent : inclElementToToggle ? onEnterEventElement : undefined
    // style={expanded ? { "height": height } : {}}
  }, /*#__PURE__*/React.createElement("div", {
    className: "ap-accordion-wrapper",
    ref: wrapperRef
  }, children))));
};
AccordionItem.propTypes = {
  style: PropTypes.object,
  className: PropTypes.string,
  itemKey: PropTypes.string.isRequired
};
AccordionItem.displayName = 'AccordionItem';
export default AccordionItem;